export default "__VITE_PUBLIC_ASSET__c399f313__"